import React from "react"
import PartnerShowcaseItem from "./partner-showcase-item"
import Slider from "react-slick"
import { generateRandomString } from "../../helpers/keys"
import useWindowWidth from "../../hooks/useWindowWidth"

export default function PartnerShowcaseComponent({ heading, partnerShowcases }) {
  // Using window width to change the partner items into / out of slider component.
  const windowWidth = useWindowWidth()

  //slick slider settings - change these if necessary.
  var settings = {
    dots: false,
    arrows: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: true,
    variableWidth: false,
    centerMode: true,
    centerPadding: "12%",
  }

  const htmlPartnerItems =
    partnerShowcases?.length > 0
      ? partnerShowcases.map((item) => {
          return (
            <PartnerShowcaseItem
              key={generateRandomString()}
              windowWidth={windowWidth}
              image={item.profileImage}
              name={item.partnerName}
              title={item.partnerTitle}
              phone={item.partnerPhone}
              email={item.partnerEmail}
            />
          )
        })
      : null

  return (
    <div className="partner-showcase-container">
      <div className="w--wider">
        <h2 data-epi-property="Heading">{heading}</h2>
        {windowWidth < 768 ? <Slider {...settings}>{htmlPartnerItems}</Slider> : <div className="grid">{htmlPartnerItems}</div>}
      </div>
    </div>
  )
}
